import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { ArrowRight } from 'lucide-react';
import './Saas.css';
import ContactFormModal from '../header/ContactFormModal';
import { useNavigate } from 'react-router-dom';

const Saas = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('saas');
    const [showContactForm, setShowContactForm] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSection(prev => prev === 'saas' ? 'smarter' : 'saas');
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{display:"flex",justifyContent:"center"}}>
    <div className="compound-container">
      {showContactForm && <ContactFormModal onClose={() => setShowContactForm(false)} />}
      
      {/* SaaS Section */}
      {activeSection === 'saas' && (
          <div className='container-card'>
        <section id='products' className="section saas-section active">
        
          <div>
            <Row className="align-items-center">
              <Col md={12} className="text-white mb-4 mb-md-0">
                <h1 className="saas-title">
                  Turn Your <span className="saas-highlight">SaaS Product</span> into an AI-Powered Platform
                </h1>

               <ul className="smarter-list mt-4">
                  <li> Competitors moving faster → Launch AI in 30 days</li>
                  <li> Disorganized data → Centralized AI dashboards</li>
                  <li> Manual processes → AI-powered automation</li>
                  <li> Generic APIs → Custom AI models, deployed securely</li>
                </ul>
              <Button
                className="contact-btn-saas mt-4"
                onClick={() => navigate("/Contact-Us")}
              >
                Contact us <ArrowRight size={20} className="ms-2" />
              </Button>
              </Col>

              <Col md={12} className="text-center">
                <div className="saas-graphics">
                  <div className="saas-cloud">
                    <div className="cloud-star"></div>
                    <div className="cloud-star"></div>
                    <div className="cloud-star"></div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          
        </section>
        </div>
      )}

      {/* Smarter Section */}
      {activeSection === 'smarter' && (
      <div className='container-card'>
        <section className="section smarter-section active">
          <div>
            <Row className="align-items-center">
              <Col md={12} className="text-white mb-4 mb-md-0">
                <h2 className="smarter-title">
                  <span className="highlight">Smarter Cloud.</span> Lower Cost. Higher Performance.
                </h2>
                <ul className="smarter-list mt-4">
                  <li>Unpredictable costs → AI-powered forecasting</li>
                  <li>Idle resources → Automated optimization</li>
                  <li>Scattered reports → Unified dashboard</li>
                  <li>Delayed anomaly detection → Real-time alerts</li>
                </ul>
              <Button
                className="contact-btn-saas mt-4"
                onClick={() => navigate("/Contact-Us")}
              >
                Contact us <ArrowRight size={20} className="ms-2" />
              </Button>
              </Col>

              <Col md={12} className="text-center">
                <div className="smarter-graphics">
                  <div className="performance-bars">
                    <div className="bar"><div className="bar-fill"></div></div>
                    <div className="bar"><div className="bar-fill"></div></div>
                    <div className="bar"><div className="bar-fill"></div></div>
                    <div className="bar"><div className="bar-fill"></div></div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

        </section>
      </div>
      )}

      {/* Progress Dots */}
      {/* <div className="progress-indicator">
        <div className={`progress-dot ${activeSection === 'saas' ? 'active' : ''}`} onClick={() => setActiveSection('saas')}></div>
        <div className={`progress-dot ${activeSection === 'smarter' ? 'active' : ''}`} onClick={() => setActiveSection('smarter')}></div>
      </div> */}
    </div>
      </div>

  );
};

export default Saas;
